'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParagraphField = (_dec = (0, _mobxReact.inject)('formStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ParagraphField, _Component);

  function ParagraphField() {
    (0, _classCallCheck3.default)(this, ParagraphField);
    return (0, _possibleConstructorReturn3.default)(this, (ParagraphField.__proto__ || (0, _getPrototypeOf2.default)(ParagraphField)).apply(this, arguments));
  }

  (0, _createClass3.default)(ParagraphField, [{
    key: 'getFormattedMarkup',
    value: function getFormattedMarkup() {
      return (0, _Parser2.default)((0, _Parser.template)(this.props.formStore, this.props.field['#message_message']));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'p',
        null,
        this.getFormattedMarkup()
      );
    }
  }]);
  return ParagraphField;
}(_react.Component), _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#message_message': _propTypes2.default.string
  }).isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired
}, _temp)) || _class) || _class);
exports.default = ParagraphField;